import React from 'react';
import Tetris from './components/Tetris';

const App = () => (
  <div classname="App">
    <Tetris />
  </div>
)
export default App;
